import React, {useEffect, useState} from 'react';
import {activeFormPanel, mrbgStore} from './mrbgRedux/index.js';
import {formsJson} from '../../mrbgLib/formsJson.js';
import MrbgLoader from './MrbgLoader.jsx';
import MrbgFormsCreator from './MrbgFormsCreator.jsx';
import MP_loginStyle from '../../static/css/MP_login.module.css';


function MrbgLogin({readySettings}){

  const
    [cls,setCls] = useState(mrbgStore.getState().activeForms[0]),
    [animation,setAnimation] = useState(false),
    description = {
      signIn: {
        title: 'wellcome back!',
        btn: 'forget password?',
        show: 'forgotPassToken'
      },
      forgotPassToken: {
        title: 'get your token',
        btn: 'back to sign in',
        show: 'signIn'
      },
      unsecurePass: {
        title: 'you must change your password',
        btn: 'back to sign in',
        show: 'signIn'
      },
      resetPass: {
        title: 'reset your password',
        btn: 'back to sign in',
        show: 'signIn'
      }
    };
  document.documentElement.setAttribute( 'lang', 'fa' );

  useEffect(()=>{
    mrbgStore.subscribe(()=>{
      if( !animation && ['forgotPassToken','resetPass','unsecurePass'].includes(mrbgStore.getState().activeForms[0]) )
        setAnimation(true);

      setCls( mrbgStore.getState().activeForms[0] )
    })
  },[cls])

  return(
    <main id={MP_loginStyle.loginMain}>
      <ul id={MP_loginStyle.formList} className={`${['signIn','resetPass'].includes(cls)? MP_loginStyle.leftForm: MP_loginStyle.rightForm} ${animation? '':MP_loginStyle.stop}`}>
        {
          Object.keys(description).map((formID,i)=> {
            if( !readySettings || !Object.hasOwn(readySettings,formID) || !formsJson.login.emp.forms[formID] )
              return '';

            var origin  = readySettings? readySettings[formID]: undefined;

            if( !origin )
              return '';

            const
              originInfo = formsJson.login.emp,
              formInfo   = originInfo.forms[formID];
            if( !formInfo?.prepared ){
              var inputName,inputIndex,colName,preparedInputs;
              if( formInfo.inputs ){
                preparedInputs = {};
                Object.keys( formInfo.inputs ).forEach( inputKey => {
                  if( /__\d+$/.test(inputKey) ){
                    [colName,inputIndex] = inputKey.split( '__' );
                    inputName = `${colName}[${inputIndex}]`;
                  }
                  else inputName = colName = inputKey;
                  preparedInputs[inputName] = { ...originInfo.columns[colName], name:inputName, ...formInfo.inputs[inputKey] }
                })
                formInfo.inputs = preparedInputs;
              }
              formInfo.prepared = true;
            }

            return(
              <li className={`${cls===formID? MP_loginStyle.active:''}`} key={i}>
                {
                  mrbgStore.getState().device === 'mob'?
                    <>
                      <h2 className={MP_loginStyle.switchTitle}>{description[formID].title}</h2>
                      <div id={MP_loginStyle[`${formID}Frame`]}  className={MP_loginStyle.formFrame}>
                        <MrbgFormsCreator {...{formID,origin,...formsJson.login.emp.forms[formID],formStyle:MP_loginStyle}}/>
                      </div>
                      <div className={MP_loginStyle.switchBtn} onClick={()=>mrbgStore.dispatch(activeFormPanel(description[formID].show))}>
                        <div>{description[formID].btn}</div>
                      </div>
                      {formID==='forgotPassToken' && <div className={MP_loginStyle.switchBtn} onClick={()=>mrbgStore.dispatch(activeFormPanel('resetPass'))}><div>reset password</div></div>}
                    </>:
                    <>
                      <div id={MP_loginStyle[`${formID}Frame`]}  className={MP_loginStyle.formFrame}>
                        <MrbgFormsCreator {...{formID,origin,...formsJson.login.emp.forms[formID],formStyle:MP_loginStyle}}/>
                      </div>
                      <div className={MP_loginStyle.description}>
                        <h2 className={MP_loginStyle.switchTitle}>{description[formID].title}</h2>
                        <div className={MP_loginStyle.switchBtn} onClick={()=>mrbgStore.dispatch(activeFormPanel(description[formID].show))}>{description[formID].btn}</div>
                        {formID==='forgotPassToken' && <div className={MP_loginStyle.switchBtn} onClick={()=>mrbgStore.dispatch(activeFormPanel('resetPass'))}><div>reset password</div></div>}
                      </div>
                    </>
                }
              </li>
            )
          })
        }
      </ul>
      <MrbgLoader />
    </main>
  );
}

export default MrbgLogin;